import React from 'react';
import {
  addPathToList,
  Allow_customers_change, Bill_confirmation, Configure_bill_confirmation, getSubCategoryId,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import SwitcherPanel from '../components/PanelsComponents/Buttons/SwitcherPanel';
import { arrangeScreenInJson } from '../screens/ScreensOrdering';

//= ========================================================================
const Panel_D04_PayBillsConfirmation = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'does_it_look_ok',
    'more_details',
    'confirm_payment',
  ];
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const subCategoryIdDefault = getSubCategoryId({ sub_category: myScreen.sub_category, duplication_number: 0 });
  const service = globJSON.configurations.services[subCategoryId];
  const { confirmation_bill } = service;
  const onValueChanged = (key, value) => {
    confirmation_bill[key] = value;
    arrangeScreenInJson(globJSON, onConfigChanged);
  };

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      panelHeadline={Bill_confirmation}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/confirmation_bill/`)}
      editTextListDefault={addPathToList(editTextList, `configurations/services/${subCategoryIdDefault}/confirmation_bill/`)}
      tooltipsTitles={service.screens_ordering}
      paragraph={Configure_bill_confirmation}
      language={language}
    >
      <SwitcherPanel
        text={Allow_customers_change}
        value={confirmation_bill.allow_customer_to_change_payment_date}
        onValueChanged={(value) => {
          onValueChanged('allow_customer_to_change_payment_date', value);
        }}
      />
    </FullPagePanel>
  );
};

export default Panel_D04_PayBillsConfirmation;
